import {Component} from '@angular/core';

@Component({
    selector: 'tfl-outgoing-3-transfer-icon',
    template: require('./outgoing-3.html')
})
export class Outgoing3TransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/outgoing/outgoing.3.transter.icon.ts